<div class="item">
    <h4 class="ui header center aligned content" data-i18n="[html]portal.no-cleaning-plans">
    </h4>
</div>
